/** Llamadas HTTP del feature Contratos. */
import { apiRequest } from "../../lib/api";

/** Cortado lo pone la orden de corte; Finalizado, finalizar el contrato. */
export type EstadoContrato = "Activo" | "Cortado" | "Finalizado";

export interface ContratoRead {
  id: number;
  empresa_id: number;
  socio_id: number;
  arranque_id: number;
  tarifa_id: number;
  fecha_inicio: string | null;
  fecha_termino: string | null;
  estado: EstadoContrato;
  fecha_corte: string | null;
  deuda_al_corte: number | null;
  costo_reconexion: number | null;
  es_arrendatario: boolean;
  nombre_usuario: string | null;
  rut_usuario: string | null;
  telefono_usuario: string | null;
  created_at: string;
  updated_at: string;
}

export interface ContratoCreatePayload {
  socio_id: number;
  arranque_id: number;
  tarifa_id: number;
  fecha_inicio?: string | null;
  estado?: EstadoContrato;
  es_arrendatario?: boolean;
  nombre_usuario?: string | null;
  rut_usuario?: string | null;
  telefono_usuario?: string | null;
}

export interface ContratoUpdatePayload {
  tarifa_id?: number;
  es_arrendatario?: boolean;
  nombre_usuario?: string | null;
  rut_usuario?: string | null;
  telefono_usuario?: string | null;
  fecha_corte?: string | null;
  deuda_al_corte?: number | null;
  costo_reconexion?: number | null;
}

export function listarContratosPorSocio(
  socioId: number,
): Promise<ContratoRead[]> {
  return apiRequest<ContratoRead[]>(`/api/v1/contratos/socio/${socioId}`);
}

export function obtenerContrato(id: number): Promise<ContratoRead> {
  return apiRequest<ContratoRead>(`/api/v1/contratos/${id}`);
}

export function crearContrato(p: ContratoCreatePayload): Promise<ContratoRead> {
  return apiRequest<ContratoRead>("/api/v1/contratos", {
    method: "POST",
    body: p,
  });
}

export function actualizarContrato(
  id: number,
  p: ContratoUpdatePayload,
): Promise<ContratoRead> {
  return apiRequest<ContratoRead>(`/api/v1/contratos/${id}`, {
    method: "PATCH",
    body: p,
  });
}

export function finalizarContrato(
  id: number,
  fechaTermino?: string | null,
): Promise<ContratoRead> {
  return apiRequest<ContratoRead>(`/api/v1/contratos/${id}/finalizar`, {
    method: "POST",
    body: { fecha_termino: fechaTermino ?? null },
  });
}

export function reactivarContrato(id: number): Promise<ContratoRead> {
  return apiRequest<ContratoRead>(`/api/v1/contratos/${id}/reactivar`, {
    method: "POST",
  });
}

// ── Traspaso de derechos (recorrido P3) ─────────────────────────────────

/** Por qué cambia el titular. La herencia no paga cuota de incorporación. */
export type MotivoTraspaso = "Herencia" | "Venta" | "Otro";

/** Qué hace el comité con lo que debía la casa. Lo decide la administradora. */
export type TratamientoDeuda =
  | "bloquear"
  | "traspasar"
  | "condonar"
  | "mantener";

export interface TraspasoPayload {
  nuevo_socio_id: number;
  motivo: MotivoTraspaso;
  tratamiento_deuda: TratamientoDeuda;
  nuevo_titular_socio: boolean;
  fecha?: string | null;
  detalle?: string | null;
}

export interface TraspasoResultado {
  contrato_anterior_id: number;
  contrato_nuevo_id: number;
  socio_anterior_id: number;
  socio_nuevo_id: number;
  deuda_de_la_casa: number;
  tratamiento_deuda: TratamientoDeuda;
  nuevo_es_socio: boolean;
  cuota_incorporacion: number;
  ajustes_ids: number[];
}

/** Deuda impaga de ESA casa, no la del socio: puede tener otro arranque. */
export function deudaDelContrato(
  id: number,
): Promise<{ contrato_id: number; deuda: number }> {
  return apiRequest<{ contrato_id: number; deuda: number }>(
    `/api/v1/contratos/${id}/deuda`,
  );
}

export function traspasarContrato(
  id: number,
  p: TraspasoPayload,
): Promise<TraspasoResultado> {
  return apiRequest<TraspasoResultado>(`/api/v1/contratos/${id}/traspasar`, {
    method: "POST",
    body: p,
  });
}

// ────────────────────────────────────────────────────────────────────────
// Conexión nueva (recorrido P9)
// ────────────────────────────────────────────────────────────────────────

export interface MaterialConexionIn {
  insumo_id: number;
  bodega_id: number;
  cantidad: string;
}

export interface ConexionPayload {
  socio_id: number;
  direccion: string;
  sector_id?: number | null;
  numero_casa?: string | null;
  referencia?: string | null;
  medidor_id: number;
  tarifa_id: number;
  lectura_inicial?: number;
  fecha?: string | null;
  titular_socio: boolean;
  /** Omitido = el paquete del comité. */
  monto_conexion?: number;
  materiales: MaterialConexionIn[];
  tecnico_id?: number | null;
  observacion?: string | null;
}

export interface ConexionResultado {
  contrato_id: number;
  arranque_id: number;
  arranque_codigo: string;
  orden_trabajo_id: number;
  orden_trabajo_numero: string;
  cargo_conexion: number;
  nuevo_es_socio: boolean;
  cuota_incorporacion: number;
  /** Costo en bodega de los materiales: control interno, no se cobra. */
  costo_materiales: number;
  ajustes_ids: number[];
}

export function conectarVecino(p: ConexionPayload): Promise<ConexionResultado> {
  return apiRequest<ConexionResultado>("/api/v1/contratos/conexion", {
    method: "POST",
    body: p,
  });
}
